import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "./redux/averageNumberOfClientsPerClassSagas";
import SectionToggle from "../../../../components/sectionToggle/sectionToggle";
import CustomDateRanges from "./smartComponents/customDateRanges";
import DatePicker from "./smartComponents/datePicker";
import TableOrStackedBarChart from "./smartComponents/tableOrStackedBarChart";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import { UpdateBtns } from "./smartComponents/UpdateBtns";

import "../attendance_common.css.scss";

const AverageNumberOfClientsPerClassModule = (props) => {
  const isLoading = useSelector((state) => state.averageNumberOfClientsPerClass.isLoading);
  const updatesLoading = useSelector(
    (state) => state.averageNumberOfClientsPerClass.updatesLoading
  );
  const initialRequest = useSelector(
    (state) => state.averageNumberOfClientsPerClass.initialRequest
  );

  let dispatch = useDispatch();

  useEffect(() => {
    !initialRequest && dispatch(actionCreators.fetchCurrentUser(props));
  }, []);

  const content = () => {
    return (
      <div>
        <div id="override-edit-selection-bar" className="edit-selections-bar">
          <div className="top-filter">
            <div className="select-box-no-width"></div>

            <div className="top-filter__right">
              <div className="select-box-no-width date-range-select-box">
                <p>Date Range</p>
                <CustomDateRanges />
              </div>

              <div className="date-select-box monthly">
                <p>Date</p>
                <DatePicker />
              </div>

              <UpdateBtns />
            </div>
          </div>
        </div>
        <div className="chart-root">
          {updatesLoading ? (
            <LoadingAnimation text="Updating data..." />
          ) : (
            <TableOrStackedBarChart />
          )}
        </div>
      </div>
    );
  };

  return (
    <div id="attendance-root">
      <SectionToggle
        autoHeight
        height={690}
        title={`Average Number of ${props.clientName} Per Class`}
        isLoading={isLoading}
        content={content()}
      />
    </div>
  );
};
export default AverageNumberOfClientsPerClassModule;
